'use client';

import { NAVIGATION_URLS } from '@libs/core';
import {
    useBasketCount,
    useCart,
    useIsExperimentFullSolution,
    useUserSession,
} from '@libs/common-next';
import { dataLayerPush, layoutEvents, getBaseUrlJoined } from '@libs/analytics';
import { UtilityNav } from '@petsmart-ui/sparky';

export const trackingData = (data: object) =>
    Object.assign(data, { ...layoutEvents.headerClick });

type UtilityIconsProps = {
    showAccountIcon?: boolean;
};

export function UtilityIcons({ showAccountIcon = true }: UtilityIconsProps) {
    const { basketCount } = useBasketCount();
    const { storageUserSession } = useUserSession();
    const { isRegistered } = storageUserSession ?? {};
    const isExperimentFullSolution = useIsExperimentFullSolution();

    const { cart } = useCart();
    const ctQty = cart?.summary?.itemCount || undefined; // We need undefined if itemCount is 0 to hide the badge;
    const qty = isExperimentFullSolution ? ctQty : basketCount;

    return (
        <UtilityNav>
            {showAccountIcon && (
                <UtilityNav.Item
                    data-testid="account-icon"
                    hideText
                    href={
                        isRegistered
                            ? NAVIGATION_URLS.velocity.account.treatOffers
                            : NAVIGATION_URLS.velocity.account.base
                    }
                    text="Account"
                    iconName="account-circle-outline"
                    onClick={() =>
                        dataLayerPush(
                            trackingData({
                                selection: 'login',
                                link_url: isRegistered
                                    ? getBaseUrlJoined(
                                          NAVIGATION_URLS.velocity.account
                                              .treatOffers
                                      )
                                    : getBaseUrlJoined(
                                          NAVIGATION_URLS.velocity.account.base
                                      ),
                            })
                        )
                    }
                />
            )}
            <UtilityNav.Item
                data-testid="cart-icon"
                hideText
                href={NAVIGATION_URLS.velocity.cart}
                className="shopping-cart"
                text="Checkout"
                iconName="cart"
                notificationText={qty?.toString()}
                onClick={() =>
                    dataLayerPush(
                        trackingData({
                            selection: 'cart',
                            link_url: getBaseUrlJoined(
                                NAVIGATION_URLS.velocity.cart
                            ),
                        })
                    )
                }
            />
        </UtilityNav>
    );
}
